import { portalRouters } from "./routes-portal";
import { provinRouters } from "./routes-province";
import { subsiteRouters } from "./routes-subsite";
import { studyzoneRouters } from "./routes-studyzone";
// import { tempThreeRouters } from "./routes-tempThree";
// import { tempOneRouters } from "./routes-tempOne";
// import { tempTwoRouters } from "./routes-tempTwo";
//配置路由，这里是个数组
const routers = [
  ...portalRouters,
  ...provinRouters,
  ...subsiteRouters,
  ...studyzoneRouters,
  // ...tempOneRouters,
  // ...tempTwoRouters,
  // ...tempThreeRouters
];
// debugger
export default routers;
